import * as React from 'react';

import ModalBase, { ModalBasicProps } from '@/components/layouts/Modal/Base';

import { Description, InfoWarningIcon, Title, Wrapper } from './style';

interface OverDeadlineModalBaseProps extends ModalBasicProps {
  isCanceled: boolean;
  isSalesSuspended: boolean;
}

const OverDeadlineModalBase: React.FC<OverDeadlineModalBaseProps> = ({
  children,
  isOpen,
  isCanceled,
  isSalesSuspended,
  handleClose,
}) => {
  const content = () => {
    if (isSalesSuspended) {
      return '販売が一時停止となっている開催のため投票できません';
    }
    if (isCanceled) {
      return '開催中止となったため投票できません';
    }
    return '投票が締め切られました';
  };

  return (
    <ModalBase
      isOpen={isOpen}
      handleClose={() => handleClose()}
      desktopWidth="840px"
    >
      <Wrapper>
        <InfoWarningIcon />
        <Title>{content()}</Title>
        <Description>
          投票パネルに未投票の買い目がある場合は削除されます。
        </Description>
        {children}
      </Wrapper>
    </ModalBase>
  );
};

export default OverDeadlineModalBase;
